var render = function render(){var _vm=this,_c=_vm._self._c;return _c('screen-dialog',{attrs:{"noLogo":""},model:{value:(_vm.showODB),callback:function ($$v) {_vm.showODB=$$v},expression:"showODB"}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('img',{staticClass:"forceFill",attrs:{"src":_vm.imageSrc,"height":"100%","width":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }